import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import { useCallback, useContext } from 'react';
import * as alerts from '../../alerts';
import { useDeleteCommentOnPublic } from '../../mutations';
import { useComments } from '../../queries';

var useDeleteComment = function useDeleteComment(_ref) {
  var publicResponseId = _ref.publicResponseId,
      commentId = _ref.commentId,
      totalFetched = _ref.totalFetched;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useDeleteCommentOnPu = useDeleteCommentOnPublic({
    onCompleted: E.match(function () {
      return showAlert(alerts.unableToDelete());
    }, function (_ref2) {
      var deleteCommentOnPublicResponse = _ref2.deleteCommentOnPublicResponse;
      if (deleteCommentOnPublicResponse.__typename === 'CommentOnPublicResponseErrors') showAlert(alerts.unableToDelete(deleteCommentOnPublicResponse.errors[0].message));
    }),
    update: function update(cache, data) {
      return pipe(data, E.chainW(function (_ref3) {
        var deleteCommentOnPublicResponse = _ref3.deleteCommentOnPublicResponse;
        return deleteCommentOnPublicResponse.__typename === 'CommentOnPublicResponseResult' ? E.right(deleteCommentOnPublicResponse) : E.left(deleteCommentOnPublicResponse);
      }), E.match(console.error, function (_ref4) {
        var result = _ref4.result;
        cache.evict({
          id: cache.identify(result)
        });
        cache.modify({
          id: cache.identify(makeReference("PublicResponse:".concat(publicResponseId))),
          fields: {
            comments: function comments(_comments) {
              return _objectSpread(_objectSpread({}, _comments !== null && _comments !== void 0 ? _comments : {}), {}, {
                totalCount: _comments !== null && _comments !== void 0 && _comments.totalCount ? _comments.totalCount - 1 : 0
              });
            }
          }
        });
        cache.gc();
      }));
    },
    refetchQueries: [{
      query: useComments.document,
      variables: {
        responseId: publicResponseId,
        commentsCursor: '0',
        first: totalFetched - 1
      }
    }],
    awaitRefetchQueries: true
  }),
      _useDeleteCommentOnPu2 = _slicedToArray(_useDeleteCommentOnPu, 1),
      deleteCommentOnPublic = _useDeleteCommentOnPu2[0];

  var deleteComment = useCallback(function () {
    return void deleteCommentOnPublic({
      variables: {
        input: commentId
      }
    });
  }, [deleteCommentOnPublic, commentId]);
  return deleteComment;
};

export default useDeleteComment;